import React from 'react'
import { component_tool } from '@/tool';
let { WizModal } = component_tool
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'
import Editor from './editor'
import teacherConfig from './config-teacher'

const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })

//配置项
let componentName = 'integrationCounseling'

const columns = [
  {
    name: 'id',
    dataIndex: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '经销商名称',
    name: 'orgName',
    dataIndex: 'orgName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '经销商简称',
    name: 'shortName',
    dataIndex: 'shortName',
    tableItem: {}
  },
  {
    title: '品牌',
    name: 'brandId',
    dataIndex: 'brandId',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'radio'
    }
  },
  {
    title: '销售代码',
    name: 'preSalesNumber',
    dataIndex: 'preSalesNumber',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '售后代码',
    name: 'afterSalesNumber',
    dataIndex: 'afterSalesNumber',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '品牌',
    name: 'brandName',
    dataIndex: 'brandName',
    tableItem: {}
  },
  {
    title: '辅导模块',
    name: 'moduleType',
    dataIndex: 'moduleType',
    dict: [
      { code: 0, codeName: '销售' },
      { code: 1, codeName: '售后' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      type: 'select'
    }
  },
  {
    title: '上线日期',
    name: 'onlineTime',
    dataIndex: 'onlineTime',
    tableItem: {}
  },
  {
    title: '辅导老师',
    name: 'teacherList',
    dataIndex: 'teacherList',
    tableItem: {
      type: 'custom',
      render: (val = []) => {
        return val.map(item => item.fullName).join(',')
      }
    }
  },
  {
    title: '辅导老师',
    name: 'teacher',
    dataIndex: 'teacher',
    searchItem: {
      ...teacherConfig,
      diy: WizTableForm,
      selectType: 'radio'
    }
  },
  {
    title: '当前流程',
    name: 'flowState',
    dataIndex: 'flowState',
    dict: [
      { code: 1, codeName: '上线通知' },
      { code: 2, codeName: '前期介入' },
      { code: 3, codeName: '预审核' },
      { code: 4, codeName: '辅导' },
      { code: 5, codeName: '跟踪' },
      { code: 6, codeName: '检核' }
    ],
    searchItem: {
      type: 'select'
    }
  },
  {
    title: '当前流程',
    name: 'flowStates',
    dataIndex: 'flowStates',
    dict: [
      { code: 1, codeName: '上线通知' },
      { code: 2, codeName: '前期介入' },
      { code: 3, codeName: '预审核' },
      { code: 4, codeName: '辅导' },
      { code: 5, codeName: '跟踪' },
      { code: 6, codeName: '检核' }
    ],
    tableItem: {
      type: 'checkbox'
    }
  },
  {
    title: '状态',
    name: 'status',
    dataIndex: 'status',
    dict: [
      { code: 0, codeName: '进行中' },
      { code: 1, codeName: '已完成' },
      { code: 2, codeName: '已撤销' }
    ],
    searchItem: {
      type: 'select',
      formatInit: () => 0
    },
    tableItem: {
      type: 'select'
    }
  }
]

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'editorAdd',
                  modalParams: {
                    title: '新增',
                    style: { minWidth: 700 },
                    diy: (e) => {
                      let editorProps = {
                        key: self.state.AddTimestamp,
                        ref: r => ref = r && r.getWrappedInstance(),
                        editorSuccess: () => {
                          self.setState({ AddTimestamp: new Date().getTime() })
                          self.doAction(apis.list)
                        },
                        ...e
                      }
                      return <Editor {...editorProps} />
                    },
                    onOk: () => {
                      ref._ok()
                    },
                    onCancel: () => {
                      console.log('* onCancel')
                      self.setState({ AddTimestamp: new Date().getTime() })
                    },
                    width: 600
                  },
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ],
          collapse: true
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateRight: () => self._renderRemind(),
        rowOperateSort: ['update', 'enter', 'revoke'],
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: { children: '编辑' },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'editorUpdate',
                modalParams: {
                  title: '编辑',
                  style: { minWidth: 700 },
                  diy: (e) => {
                    let editorProps = {
                      key: 'editorUpdate_' + e.record.id,
                      ref: r => ref = r && r.getWrappedInstance(),
                      editorSuccess: () => {
                        self.doAction(apis.list)
                      },
                      ...e
                    }
                    return <Editor {...editorProps} />
                  },
                  onOk: () => {
                    ref._ok()
                  },
                  width: 600
                },
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = record.status !== 0
              return { disabled }
            }
          },
          {
            key: 'enter',
            custom: true,
            params: { children: '进入' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/integrationCounseling/manager/counselingProcess'
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = record.status === 2
              return { disabled }
            }
          },
          {
            key: 'revoke',
            custom: true,
            params: { children: '撤销' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'revoke',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要撤销该融入辅导吗？`
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status: 2,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = record.status !== 0
              return { disabled }
            }
          }
        ]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: { status: 0 }
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  remind: {
    path: `${componentName}/remind`,
    payload: {
      key: `${componentName}@remind`,
      apiParams: {}
    }
  },
  revoke: {
    path: `${componentName}/revoke`,
    payload: {
      key: `${componentName}@revoke`,
      apiParams: {}
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'remind'],
    needLoading: true,
    keepInitApiParams:true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
